import React from 'react';

export const Page404: React.FC = () => {
  return (
    <div className="page-404">
      These are not the images you are looking 404...
    </div>
  );
};
